import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => (
  bindActionCreators({

  }, dispatch)
)

class SearchResultEmailByASN extends Component {
  render() {
    const { data } = this.props
    const { as_number, as_bgp_prefix, as_country_code, as_registry, as_organization, as_allocated_date, as_name } = data
    return (
      <div className="email-container">
        <h3>AS Information</h3>
        <table><tbody>
          <tr>
            <td>AS Number:</td>
            <td>{as_number || ""}</td>
          </tr>
          <tr>
            <td>AS BGP Prefix:</td>
            <td>{as_bgp_prefix || ""}</td>
          </tr>
          <tr>
            <td>AS Country Code:</td>
            <td>{as_country_code || ""}</td>
          </tr>
          <tr>
            <td>AS Registry:</td>
            <td>{as_registry || ""}</td>
          </tr>
          <tr>
            <td>AS Organization:</td>
            <td>{as_organization || ""}</td>
          </tr>
          <tr>
            <td>AS Allocated  :</td>
            <td>{as_allocated_date || ""}</td>
          </tr>
          <tr>
            <td>AS Name:</td>
            <td>{as_name || ""}</td>
          </tr>
        </tbody></table>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultEmailByASN);